import { render, staticRenderFns } from "./RuleController.vue?vue&type=template&id=239003a9&lang=pug"
import script from "./RuleController.vue?vue&type=script&lang=js"
export * from "./RuleController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports